import React from 'react'
import { keyframes } from '@emotion/react'
import { Box } from '@mui/material'
import { styles } from './styles'
import { Direction, TRANSITION_DURATION } from './types'

const slideForward = keyframes`
  from { opacity: 0; transform: translate3d(100%, 0, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
`

const slideBackward = keyframes`
  from { opacity: 0; transform: translate3d(-100%, 0, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
`

export const AnimatedFragment = ({
  children,
  animationKey,
  direction = Direction.Forward
}: {
  children: React.ReactNode
  animationKey: string
  direction?: Direction
}) => (
  <Box sx={styles.animatedContainer}>
    <Box
      key={`fragment-${animationKey}`}
      sx={[
        styles.animatedContent,
        {
          animation: `${
            direction === Direction.Forward ? slideForward : slideBackward
          } ${TRANSITION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1) both`
        }
      ]}
    >
      {children}
    </Box>
  </Box>
)
